import Button, { Color, Size, TextOverflow, TextSize } from 'lib/Button';
import React from 'react';
import { NavigationTileProps } from './NavigationTile.types';

const NavigationTile: React.FC<NavigationTileProps> = ({ label, svg, onClick, isDisabled = false }) => {
  return (
    <Button
      label={label}
      onClick={onClick}
      size={Size.WIDE}
      color={Color.TERTIARY}
      svg={svg}
      svgClassnames="w-6 h-6"
      classNames="p-3 flex-col"
      textSize={TextSize.SMALL}
      textOverflow={TextOverflow.VISIBLE}
      isDisabled={isDisabled}
    />
  );
};

export default NavigationTile;
